<template>
  <v-container class="pt-0" style="overflow: hidden">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card
          outlined
          class="mx-4 mb-4"
          elevation="0"
          height="calc(100vh - 250px)"
        >
          <v-card-text
            class="ql-editor"
            style="height: 100%; overflow-y: auto"
            v-html="formatCondition(condition)"
          ></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service.js";
import headerTextBg from "../../../components/headerTextBg.vue";

export default {
  components: { headerTextBg },
  name: "setting",
  data() {
    return {
      condition: null,
      title: "",
    };
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
  },
  created() {
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "privacy");
    this.title = model?.name;
    Axios.get(`getCondition?site_id=${this.site.id}`)
      .then((res) => {
        if (res.data.status === "success") {
          this.condition = res.data.condition;
        }
        if (!this.condition) {
          this.condition = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
            "dataNotFound"
          )}</div>`;
        }
      })
      .catch((err) => {
        this.$swal.fire({
          icon: "error",
          text: err.response.data.message,
          showConfirmButton: false,
          timer: 2000,
        });
      });
  },
  methods: {
    formatCondition(param) {
      let html = param || "";
      if (html.includes("<iframe")) {
        html = html.replaceAll("<iframe", "<iframe style='max-width: 100%;'");
      }
      if (html.includes("<img")) {
        html = html.replaceAll(
          "<img",
          "<img style='max-width: 100%;width: auto !important;height: auto !important;'"
        );
      }
      return html;
    },
  },
};
</script>

<style scoped></style>
